import * as yup from "yup";

const perfilesValidacionEsquema = yup.object().shape({
    nombre: yup.string().required(),
    menus: yup.array().required().min(1)
});

export default perfilesValidacionEsquema;
